module.exports = {"name":"@atlaskit/inline-dialog","version":"9.0.1"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/field-base/node_modules/@atlaskit/inline-dialog/dist/package.json
// module id = 1239
// module chunks = 0